import React from 'react'

import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

import useStyles from './Style'

import DataItem from './DataItem'

const DadosEscola = ({ escola }) => {
    const classes = useStyles();
    return (
        <div className={classes.section}>
            <Typography className={classes.title}>Dados da Escola de Atuação</Typography>
            <Grid container spacing={2}>
                <DataItem label="INEP" value={escola.inep} sm={2} />
                <DataItem label="Nome da Escola" value={escola.nome} sm={10} />
                <DataItem label="Dependência Administrativa" value={escola.dependenciaAdministrativa} sm={4} />
                <DataItem label="Anos Letivos de Atuação" value={escola.anosLetivos} sm={8} />
            </Grid>
        </div>
    )
}

export default DadosEscola;